
/**
 * token = {
 *    expires_in: Number, (ms)
 *    token_expires_time: Number, (ms)
 *    access_token: String, (type + access)
 *    refresh_token: String (type + refresh)
 *  }
*/
export const tokenFormat = (v) => {
  const token = v
  if (typeof token === 'object') {
    return {
      expires_in: token.expires_in * 1000,
      token_expires_time: token.expires_in * 1000 + new Date().getTime(),
      access_token: `${token.token_type} ${token.access_token}`,
      refresh_token: token.refresh_token,
      session_id: token.session_id,
      session_mode: token.session_mode,
      idle_last_activity_at: Date.now()
    }
  }
  return new Error('This token is an illegal structure')
}

// Keep legacy idle time with the login it belongs to, across full-page SSO navigation.
const IDLE_ACTIVITY_KEY = 'legacy-idle-activity'
export const writeIdleActivityAt = (time) => {
  try {
    const token = JSON.parse(localStorage.getItem('token') || 'null')
    if (token?.access_token && token.session_mode !== 'shared' && Number.isFinite(token.token_expires_time)) {
      localStorage.setItem(IDLE_ACTIVITY_KEY, JSON.stringify({
        login_expires_at: token.token_expires_time,
        session_id: token.session_id || '',
        at: time
      }))
    }
  } catch (_) {}
}

export const readIdleActivityAt = (fallback) => {
  try {
    const token = JSON.parse(localStorage.getItem('token') || 'null')
    if (!token?.access_token || token.session_mode === 'shared') return fallback
    const activity = JSON.parse(localStorage.getItem(IDLE_ACTIVITY_KEY) || 'null')
    const sameLogin = activity && activity.login_expires_at === token.token_expires_time &&
      (!activity.session_id || !token.session_id || activity.session_id === token.session_id)
    const time = sameLogin ? activity.at : token.idle_last_activity_at
    if (Number.isFinite(time) && time >= 0 && time <= Date.now()) return time
    writeIdleActivityAt(fallback)
  } catch (_) {}
  return fallback
}
